import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export default async function getTimeCompletelyBooked(day, callback) {
	var salesAgentCount;
	await firebaseRef
		.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.once('value', (snapshot) => {
			var salesAgentsObj = snapshot.val();

			var salsAgentsKeys = Object.keys(salesAgentsObj);

			salesAgentCount = salsAgentsKeys.length;
		});

	//check if the time is repeated same number as the sales agent count. if so then the time is completely booked
	function checkIfTimeSlotFull(array, callback) {
		let counts = {};
		var returnedArr = [];

		for (let i = 0; i < array.length; i++) {
			if (counts[array[i]]) {
				counts[array[i]] += 1;
			} else {
				counts[array[i]] = 1;
			}
		}

		console.log('salesAgentCount', salesAgentCount);
		for (let prop in counts) {
			if (counts[prop] === salesAgentCount) {
				returnedArr.push(prop);
			}
		}

		callback(returnedArr);
	}

	await firebaseRef
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			var appointmentsObj = snapshot.val();

			var appointmentsKeys = Object.keys(appointmentsObj);

			var appointmentArr = [];
			var timeArr = [];

			appointmentsKeys?.forEach((key) => {
				var salesAgentId = appointmentsObj[key]['createrID'];
				var timeOfAppointment =
					appointmentsObj[key]['timeOfAppointment'];

				var instantVideoCall = appointmentsObj[key]?.instantVideoCall;

				var minTimeMinutes = dayjs(timeOfAppointment).format('HH');
				var daysAvailable = dayjs(timeOfAppointment).format('DDMMYY');
				var dayClicked = dayjs(day).format('DDMMYY');

				console.log('minTimeMinutes', minTimeMinutes);

				var appointmentObj = {
					salesAgentId: salesAgentId,
					timeOfAppointment: timeOfAppointment,
				};

				if (
					instantVideoCall !== true &&
					minTimeMinutes >= 13 &&
					daysAvailable === dayClicked
				) {
					appointmentArr.push(appointmentObj);

					timeArr.push(appointmentObj.timeOfAppointment);
				}
			});

			checkIfTimeSlotFull(timeArr, (returned) => {
				console.log('checkIfTimeSlotFull returned', returned);
				callback(returned);
			});

			console.log('appointmentArr', appointmentArr);
		});
}
